import React, { useState } from 'react';
import { getImageUrl } from 'helpers/Image.helper';
import { INoticeContent } from 'api/interfaces/bbs.interface';

interface NoticeImageProps {
    content: INoticeContent;
}

const NoticeImage: React.FC<NoticeImageProps> = ({ content }) => {
    const [imageError, setImageError] = useState({ pc: false, mobile: false });

    // PC용 이미지와 모바일용 이미지가 모두 있는지 확인
    const hasPcImage = content.attachedPcImage && (
        content.attachedPcImage.subUrl || content.attachedPcImageUrl
    );
    const hasMobileImage = content.attachedMobileImage && (
        content.attachedMobileImage.subUrl || content.attachedMobileImageUrl
    );

    // 이미지가 하나도 없으면 렌더링하지 않음
    if (!hasPcImage && !hasMobileImage) {
        return null;
    }

    const handleImageError = (type: 'pc' | 'mobile') => {
        setImageError(prev => ({ ...prev, [type]: true }));
    };

    return (
        <div className="my-6">
            {/* PC용 이미지 - PC 크기에서만 표시 */}
            {hasPcImage && !imageError.pc && (
                <div className="hidden lg:block">
                    <img
                        src={getImageUrl(content.attachedPcImage)}
                        alt={content.title || '공지사항 이미지'}
                        className="w-full h-auto rounded-lg shadow-sm"
                        onError={() => handleImageError('pc')}
                    />
                </div>
            )}

            {/* 모바일용 이미지 - 태블릿 이하 크기에서만 표시 */}
            {hasMobileImage && !imageError.mobile && (
                <div className="block lg:hidden">
                    <img
                        src={getImageUrl(content.attachedMobileImage)}
                        alt={content.title || '공지사항 이미지'}
                        className="w-full h-auto rounded-lg shadow-sm"
                        onError={() => handleImageError('mobile')}
                    />
                </div>
            )}

            {/* PC 이미지가 없거나 에러가 발생한 경우 - 모바일 이미지를 모든 크기에서 표시 */}
            {(!hasPcImage || imageError.pc) && hasMobileImage && !imageError.mobile && (
                <div className="block">
                    <img
                        src={getImageUrl(content.attachedMobileImage)}
                        alt={content.title || '공지사항 이미지'}
                        className="w-full h-auto rounded-lg shadow-sm"
                        onError={() => handleImageError('mobile')}
                    />
                </div>
            )}

            {/* 모바일 이미지가 없거나 에러가 발생한 경우 - PC 이미지를 모든 크기에서 표시 */}
            {(!hasMobileImage || imageError.mobile) && hasPcImage && !imageError.pc && (
                <div className="block">
                    <img
                        src={getImageUrl(content.attachedPcImage)}
                        alt={content.title || '공지사항 이미지'}
                        className="w-full h-auto rounded-lg shadow-sm"
                        onError={() => handleImageError('pc')}
                    />
                </div>
            )}
        </div>
    );
};

export default NoticeImage;
